<template>
  <div class="strategy-container">
    <!-- <Edit :editInfo="editInfo" :show="showDrawer" @close="close"></Edit> -->
    <tabs>
      <template #space>
        <search ref="searchRef" />
        <my-table :data="detail" />
      </template>

      <template #device>
        <search ref="searchRef" />
        <my-table @show="showEdit" :data="detail" />
      </template>
    </tabs>
    <plan-edit
      v-if="editShow"
      @onGetList="editClose"
      @close="editClose"
      :show="editShow"
      :editInfo="editInfo"
    />
  </div>
</template>
<script>
import { defineComponent, ref, onMounted } from "vue";
import MyTable from "@/components/dashboard/devops/backup/plan/table";
import Tabs from "@/components/dashboard/devops/backup/plan/tabs";
import Search from "@/components/dashboard/devops/backup/plan/search";
import { getBackupPlanList } from "@/api/dashboard/devops/backup/index";
import useApi from "@/utils/hooks/use-api";
import Edit from "@/components/dashboard/devops/backup/plan/edit";
import { useStore } from "vuex";

export default defineComponent({
  components: {
    MyTable,
    Tabs,
    Search,
    [Edit.name]: Edit
  },
  setup() {
    const store = useStore();
    const { loading, result, fetchResource } = useApi(getBackupPlanList);
    const detail = ref({});
    const searchRef = ref(null);
    const getList = async (params) => {
      if (store.state.backup.device.result) {
        return (detail.value = store.state.backup.device);
      }

      await fetchResource(Object.assign({}, params));
      detail.value = result.value.data;
      store.commit("backup/setDevice", result.value.data);
    };
    onMounted(async () => {
      await getList({});
    });

    const editInfo = ref(null);
    const editShow = ref(false);
    const showEdit = (info) => {
      editInfo.value = info;
      editShow.value = true;
    };
    const editClose = () => {
      editShow.value = false;
    };

    return { getList, loading, detail, searchRef, editShow, showEdit, editInfo, editClose };
  }
});
</script>
<style scoped lang="less">
.strategy-container {
  padding: 24px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
}
</style>
